export default "__VITE_ASSET__BvWR3c$t__"